


export const ELEVATED_PRIVILEGES_FLAG = Symbol("elevated-privileges");


export const REQUEST_ADMIN_PRIVILEGES_FLAG = Symbol("request-admin-privileges");
export const GRANT_ADMIN_PRIVILEGES_FLAG = Symbol("grant-admin-privileges");
export const ADMIN_PRIVILEGES_FLAG = Symbol("admin-privileges");


export const CAN_POST_FLAG = Symbol("can-post-privileges");


export const USER_ID_FLAG = Symbol("user-ID");

export const REQUESTING_SMF_ROUTE_FLAG = Symbol("requesting-SMF-route");
export const CURRENT_SMF_ROUTE_FLAG = Symbol("current-SMF-route");
// export const REQUESTING_COMPONENT_FLAG = Symbol("requesting-component");
export const CLIENT_PERMISSIONS_FLAG = Symbol("client-permissions");


export const NO_TRACE_FLAG = Symbol("no-trace");


